import * as React from "react";
import { Label, List, SemanticSIZES,Header } from "semantic-ui-react";
import { ColorProp } from "../../../constants/type";
import { convertToCurrencyNumber } from "../../../utils/convert-to-currency-number";
import { getColor } from "../../../utils/get-color";

export interface ICurrenecyText {
  size?: SemanticSIZES;
  shade?: ColorProp;
  underline?: boolean;
  children: number | any;
  unit?: string;
  className?: string;
  numberOfdecimal?: number;
  pureValue?: boolean;
  style?: any;
  disabledInline?: boolean;
  noPadding?: boolean;
  isHeader?: boolean;
}

class CurrenecyText extends React.Component<ICurrenecyText> {
  public render() {
    const {
      size,
      underline,
      style,
      unit,
      numberOfdecimal,
      pureValue,
      disabledInline,
      className,
      children,
      noPadding,
      isHeader,
      ...rest
    } = this.props;
    const textColor = this.textColor();
    const textSize: any = this.textSize();
    return (
      <React.Fragment>
        {pureValue ? (
          convertToCurrencyNumber(children, numberOfdecimal)
        ) :(
          <Label
            {...rest}
            className={`label-text ${className}`}
            style={{
              color: textColor,
              textDecoration: underline ? "underline" : "none",
              whiteSpace: disabledInline ? "normal" : "nowrap", // ทำให้ value กับ unit อยู่บรรทัดเดียวกัน
              ...style,
            }}
            size={textSize}
          >
            {isHeader? 
           
              <List horizontal>
              <List.Item style={noPadding ? styles.noPadding : undefined}>
              <Header size='small'>{convertToCurrencyNumber(children, numberOfdecimal)}</Header>
              </List.Item>
              {unit ? <List.Item style={noPadding ? styles.noPadding : undefined}>  <Header size='small'>{unit}</Header></List.Item> : null}
            </List> 
          :
            <List horizontal>
              <List.Item style={noPadding ? styles.noPadding : undefined}>
                {convertToCurrencyNumber(children, numberOfdecimal)}
              </List.Item>
              {unit ? <List.Item style={noPadding ? styles.noPadding : undefined}>{unit}</List.Item> : null}
            </List>
            }
          </Label>
        )}
      </React.Fragment>
    );
  }

  private textColor = () => {
    const { shade } = this.props;

    return getColor(shade);
  };
  private textSize = () => {
    const { size } = this.props;
    return size || "large";
  };
}
const styles = {
  noPadding: {
    padding: 0,
  },
};
export default CurrenecyText;
